module.exports = __webpack_public_path__ + "media/images/favicons_staging/mstile-310x310-4aeac9f4d2430be1833475448b88fbd1.png";